import { CCard } from '@coreui/react'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatPrice } from 'src/utils/commonUtils'
import styles from './budgetCard.module.scss'

const BudgetCard = ({ title, value }) => {
  const { t } = useTranslation()

  return (
    <CCard className={styles.cardStyle}>
      <div className={styles.contentRowStyle}>
        <div>
          <div className={styles.cardTitle}>{title}</div>
          <div className={styles.cardSubtitle}>{t('invoices.estimatedBudget')}</div>
        </div>
        <div className={styles.budgetDivStyle}>
          <div className={styles.budgetIconStyle}>
            <RequestQuoteIcon color="apple" sx={{ fontSize: '2.25rem' }} />
          </div>
          <div>
            <div className={styles.budgetValueStyle}>{formatPrice(value)}</div>
          </div>
        </div>
      </div>
    </CCard>
  )
}

BudgetCard.defaultProps = {
  title: '',
  value: 0,
}

BudgetCard.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
}

export default BudgetCard
